export default "__VITE_ASSET__zSCWjOGG__"